<app-dashboard-card
  [title]="title"
  [icon]="icon"
  [accentColor]="accentColor"
  [badge]="badge"
  [badgeTooltip]="badgeTooltip"
  [titleLink]="titleLink"
  [titleQueryParams]="titleQueryParams"
  [isLoading]="isLoading"
  [hasError]="!!errorMessage"
  [errorMessage]="errorMessage ?? ''"
  errorIcon="sync_problem"
  [isEmpty]="!isLoading && rows.length === 0"
  [emptyIcon]="emptyIcon"
  [emptyMessage]="emptyMessage"
  [contentPadding]="contentPadding"
  [showFooter]="shouldShowFooter"
  (retry)="retry.emit()">
  <ng-container card-actions>
    <ng-content select="[card-actions]"></ng-content>
  </ng-container>

  <ng-container card-content>
    <div class="dashboard-table-shell" *ngIf="!isLoading && rows.length > 0">
      <table class="dashboard-table">
        <colgroup>
          <col
            *ngFor="let column of columns"
            [style.width]="column.width">
        </colgroup>
        <thead>
          <tr>
            <th
              *ngFor="let column of columns"
              [class]="getHeaderClass(column)">
              {{ column.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let row of displayedRows"
            class="dashboard-table__row"
            (click)="rowClick.emit(row)">
            <td
              *ngFor="let column of columns"
              [class]="getCellClass(row, column)">
              <ng-container *ngIf="getCellValue(row, column) as cellValue">
                <ng-container *ngIf="isMetricStackValue(cellValue); else textCell">
                  <span class="metric-stack">
                    <span class="metric-stack__rows">
                      <span *ngFor="let metric of cellValue.rows" class="metric-stack__row">
                        <span class="metric-stack__label">{{ metric.label }}</span>
                        <span class="metric-stack__value">{{ metric.value }}</span>
                      </span>
                    </span>
                    <span class="metric-stack__total">
                      <span *ngIf="cellValue.total.label" class="metric-stack__total-label">{{ cellValue.total.label }}</span>
                      <span class="metric-stack__total-value">{{ cellValue.total.value }}</span>
                    </span>
                  </span>
                </ng-container>

                <ng-template #textCell>{{ cellValue }}</ng-template>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-container card-footer>
    <mat-paginator
      *ngIf="showPaginator && rows.length > pageSize"
      [hidePageSize]="true"
      [length]="rows.length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[pageSize]"
      (page)="onPageChange($event)">
    </mat-paginator>
    <ng-content select="[card-footer]"></ng-content>
  </ng-container>
</app-dashboard-card>
